// @ts-nocheck
import styled from 'styled-components';

export const Container = styled.div`
    form {
        margin: 48px 24px;
        max-width: 450px;
        display: grid;
        gap: 24px;
        input[type="number"]::-webkit-outer-spin-button, 
        input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        input[type="number"] {
            -moz-appearance: textfield;
        }
    }
    .toggle {
        display: flex;
    }
`;

export const WrapperButton = styled.div`
    max-width: 100%;
    display: flex;
    gap: 24px;
    button {
        width: 100%;
        max-width: 200px;
        margin: auto;
    }
    .danger-btn, .warning-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        border-radius: 100px;
        border: 2px solid transparent;
        color: #fff;
        cursor: pointer;
    }
    .danger-btn {
        background-color: #d32f2f;
        border-color: #d32f2f;
    }
    .warning-btn {
        background-color: #ed6c02;
        border-color: #ed6c02;
    }
`;

export const TextModal = styled.div`
    font-size: 22px;
    text-align: center;
    margin: 32px;
`